export default "__VITE_ASSET__D6uK57g6__"